import { useContext } from 'react'
import { StepsContext } from '../../contexts/steps'

export const useStepContext = () => {
  const context = useContext(StepsContext)

  if (!context) {
    throw new Error()
  }

  return context
}
